import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=1a6c4846&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=1a6c4846&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c4846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6c4846')) {
      api.createRecord('1a6c4846', component.options)
    } else {
      api.reload('1a6c4846', component.options)
    }
    module.hot.accept("./BaseDialog.vue?vue&type=template&id=1a6c4846&scoped=true", function () {
      api.rerender('1a6c4846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BaseDialog.vue"
export default component.exports